import API from "../../../app/api";

export const getSummary = async (checkoutId) => {
  try {
    const { data } = await API.get(`/checkout/${checkoutId}/summary`);
    return data;
  } catch (error) {
    console.error("Summary API Error:", error);
    throw error;
  }
};